<script>
import pagination from "@/mixins/pagination";
import tableSearch from "@/mixins/tableSearch";
import router from "@/mixins/router";
import _debounce from "lodash/debounce";
import RefreshSearchBtn from "@/views/pages/project/sale/RefreshSearchBtn.vue";
import CommonTableComponent from "@/components/table.vue";
import apiEndpoints from "@/services/apiEndpoints";

export default {
  name: "ContractTab",
  components: {
    RefreshSearchBtn,
    CommonTableComponent
  },
  mixins: [pagination, tableSearch, router],
  props: {
    activeTabIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      contracts: [],
      filters: {
        column: this.$route.query.column || "contract_cd",
        dir: this.$route.query.dir || "ASC"
      }
    };
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      this.$emit("get-data", true);
      const url = apiEndpoints.projects_sales_contracts.replace(
        ":id",
        this.$route.params.id
      );
      const sendApiProject = await this.$http.get(url, this.filters);
      const { status, data } = sendApiProject;

      if (status && data.result) {
        this.contracts = data.result;
      }
      this.$emit("get-data", false);
    },
    onRefreshSearch() {
      this.$router.replace({
        name: this.$route.name,
        query: { ...this.customQuery, searchToken: this.getSearchToken() }
      });
    },
    redirecDetail(data) {
      let that = this;
      if (data.type == 'treatment') {
        return  this.redirectRoute(
          'projects.sales.contracts.detail',
          {
            id: that.projectId,
            contract_id: data.id
          },
          {},
          that.queryPage,
          'projects/sales/contract'
        )
      }
      return  this.redirectRoute(
        'projects.sales.transport.detail',
        {
          id: that.projectId,
          contract_id: data.id
        },
        {},
        that.queryPage,
        'projects/sales/contract'
      )
    }
  },
  watch: {
    "filters.page": {
      immediate: false,
      handler() {
        this.updateUrlFilters();
      }
    }
  },
  computed: {
    customQuery() {
      return {
        activeTabIndex: this.activeTabIndex
      };
    },
    headers() {
      return [
        {
          text: "CA/CB管理番号",
          value: "contract_cd",
          sortable: true,
          width: 10
        },
        {
          text: "契約名",
          value: "contract_name",
          sortable: true
        },
        {
          text: "契約有効期限",
          value: "expiration_date",
          sortable: true
        },
        {
          text: "自動更新",
          value: "is_term_continuation",
          sortable: true
        }
      ];
    },
    projectId() {
      return this.$route.params.id;
    },
    queryPage() {
      return this.$route.query;
    }
  }
};
</script>
<template>
  <b-container>
    <b-row align-h="center">
      <h5>契約一覧</h5>
      <b-col class="mt-1">
        <CommonTableComponent
          :height-class="`table-wrapper-500`"
          :scrollAble="contracts.length >= this.$constant.scroll_able_records"
        >
          <thead class="table-light">
            <tr>
              <th
                :style="`width: ${item.width}`"
                v-for="(item, index) in headers"
                :key="index"
                :class="getHeaderClass(item)"
              >
                <span v-if="item.sortable" @click="clickSort(item.value)">
                  {{ item.text }}
                  <i :class="getSortClass(item.value)"></i>
                </span>
                <span v-else>
                  {{ item.text }}
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in contracts"
              :key="index"
              class="cursor-pointer"
              @click.exact="redirecDetail(item)"
              @click.ctrl="
                redirectRouteTargetBlank(
                  item.type === 'treatment' ? 'projects.sales.contracts.detail' : 'projects.sales.transport.detail',
                  {
                    id: projectId,
                    contract_id: item.id
                  },
                  {},
                  queryPage,
                  'projects/sales/contract'
                )
              "
            >
              <td>
                {{ item.contract_cd }}
              </td>
              <td>
                {{ item.contract_name || "" }}
              </td>
              <td>
                {{ item.expiration_date }}
              </td>
              <td>
                {{ item.is_term_continuation == 1 ? "あり" : "" }}
              </td>
            </tr>
            <tr v-if="!contracts.length">
              <td colspan="6" class="text-center">
                データなし。
              </td>
            </tr>
          </tbody>
        </CommonTableComponent>
      </b-col>
    </b-row>
  </b-container>
</template>
